<script setup lang="ts">
import ResourceDetail from '@shell/components/ResourceDetail/index.vue';
</script>

<template>
  <ResourceDetail />
</template>

